<template>
  <div class="content">
    <TopNavigation :TopAct="'2'"/>
    <div :class="this.$store.state.webNavigator=='pc'?'':''">
      <listTopImg/>
      <div class="max1720 marginAuto">
        <productPage
          :pageIndex="current"
          @getTotal="getTotal"/>
        <Pagination
          :total="total"
          :current-page='current'
          @pagechange="getPage"/>
      </div>
    </div>
    <FooterNavigation/>
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import productPage from './productPage/productPage';
import listTopImg from '../../components/listTopImg/listTopImg';
import Pagination from '../../components/Pagiantion/Pagination';
export default {
  name: 'productList',
  components: {TopNavigation, FooterNavigation, productPage, listTopImg, Pagination, },
  title () {
    return {
      title: '全线产品-脂玫乐',
      keywords: '全线产品-脂玫乐',
      description: '全线产品-脂玫乐',
    };
  },
  data () {
    return {
      total: 1,
      current: 1,
    };
  },
  watch: {
    $route () {
      this.current = parseInt(this.$route.params.page);
    },
  },
  methods: {
    getTotal (data) {
      this.total = data;
    },
    getPage (data) {
      this.$router.push({path: '/' + this.$route.path.split('/')[1] + '/' + data + '/' + this.$route.params.html, });
    },
  },
  mounted () {
    this.current = parseInt(this.$route.params.page);
  },
};
</script>

<style lang="less" scoped>
@import url("productList.less");
</style>



// WEBPACK FOOTER //
// productList.vue